<template>
  <div class="samllBox">
    <div class="box_1">
      <span class="text_1">共{{ studentNums }}名学生</span>
    </div>
    <div class="bigBox">
      <div class="box_2">
        <div class="box2_1">
          <span class="search-btn">
            <el-input
              placeholder="请输入姓名"
              prefix-icon="el-icon-search"
              v-model="studentName"
              :clearable="true"
              @clear="clearClick"
            ></el-input>
          </span>
          <span class="course-btn" v-if="false">
            <el-select v-model="courseValue" placeholder="课程">
              <el-option
                v-for="item in classInfoArray"
                :key="item.id"
                :label="item.classInfo"
                :value="item.id"
              ></el-option>
            </el-select>
          </span>
          <span class="class-btn">
            <el-select v-model="classValue" placeholder="班级">
              <el-option label="全部班级" value></el-option>
              <el-option
                v-for="item in classInfoArray"
                :key="item.id"
                :label="item.classInfo"
                :value="item.id"
              ></el-option>
            </el-select>
          </span>
          <span>
            <el-button type="primary" @click="searchClick" icon="el-icon-search"
              >搜索</el-button
            >
          </span>
        </div>
        <div class="box2_2">
          <span>
            <i class="el-icon-plus"></i>
          </span>
          <el-button type="text" class="addButton" @click="dialogVisible = true"
            >添加班级</el-button
          >
          <el-dialog title="添加班级" :visible.sync="dialogVisible" width="30%">
            <el-form
              :model="addClassForm"
              ref="addClassFormRef"
              label-width="100px"
            >
              <el-form-item label="年级名称：" prop="grade_name">
                <!-- <el-input v-model="addClassForm.gradeName" style="width: 80%"></el-input> -->
                <el-select
                  v-model="addClassForm.gradeName"
                  placeholder="请选择年级"
                  style="width: 80%"
                >
                  <el-option
                    :label="numTochinese(item) + '年级'"
                    :value="item"
                    v-for="item in 9"
                    :key="item"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="班级名称：" prop="cat_name">
                <!-- <el-input v-model="addClassForm.className" style="width: 80%"></el-input> -->
                <el-select
                  v-model="addClassForm.className"
                  placeholder="请选择班级"
                  style="width: 80%"
                >
                  <el-option
                    :label="item + '班'"
                    :value="item"
                    v-for="item in 20"
                    :key="item"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属学校：" prop="schoolId">
                <el-select
                  v-model="addClassForm.schoolId"
                  placeholder="请选择"
                  style="width: 80%"
                >
                  <el-option
                    v-for="item in teacherArray"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="addDialogVisible"
                >确 定</el-button
              >
            </span>
          </el-dialog>
          <span>
            <i class="el-icon-plus"></i>
          </span>
          <el-button type="text" class="addButton" @click="addClassDialog"
            >添加学生</el-button
          >
          <el-dialog
            :visible.sync="dialogVisible1"
            width="540px"
            :before-close="cancleClick"
          >
            <el-form
              :model="addStudentForm"
              :rules="addStudentFormRules"
              ref="addStudentForm"
              label-width="100px"
            >
              <el-form-item label="学生名称：" prop="studentName">
                <el-input
                  v-model="addStudentForm.studentName"
                  style="width: 95%"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="学籍号：" prop="studentCode">
              <el-input
                v-model="addStudentForm.studentCode"
                style="width: 80%"
              ></el-input>
              </el-form-item>-->
              <el-form-item label="出生日期：" prop="birthday">
                <el-date-picker
                  v-model="addStudentForm.birthday"
                  type="date"
                  placeholder="请输入内容"
                  style="width: 95%"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="性别：" prop="sex">
                <el-select
                  v-model="addStudentForm.sex"
                  placeholder="请选择"
                  style="width: 95%"
                >
                  <el-option label="男" value="M"></el-option>
                  <el-option label="女" value="W"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属班级：" prop="classValue1">
                <el-select
                  v-model="addStudentForm.classValue1"
                  placeholder="请选择"
                  style="width: 95%"
                >
                  <el-option
                    v-for="item in classInfoArray"
                    :key="item.id"
                    :label="item.classInfo"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属学校：" prop="schoolId">
                <el-select
                  v-model="addStudentForm.schoolId"
                  placeholder="请选择"
                  style="width: 95%"
                >
                  <el-option
                    v-for="item in teacherArray"
                    :label="item.name"
                    :key="item.id"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="cancleClick">取 消</el-button>
              <el-button type="primary" @click="addStudentVisible"
                >确 定</el-button
              >
            </span>
          </el-dialog>

          <el-button
            style="margin-left: 30px"
            type="text"
            class="addButton"
            @click="goTopic"
            >量表列表</el-button
          >
        </div>
      </div>
      <div>
        <info
          v-if="studentListArray.length"
          :studentListArray="studentListArray"
          @updataStudent="updataStudent"
          @reload="studentList"
        ></info>
      </div>
      <div class="block">
        <el-pagination
          bckground
          @current-change="handleChangePage"
          :current-page="pagination.currentPage"
          :page-size="pagination.limit"
          layout="prev, pager, next"
          :total="pagination.total"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>


<script>
import { schoolList, updaStudent } from '@/api/student/index.js';
import info from './components/info.vue';
import { numTochinese } from '@/utils/index.js';
import {
  studentList,
  addClass,
  addStudent,
  classInfo
} from '@/api/student/index.js';

export default {
  components: {
    info
  },
  data() {
    return {
      studentNums: 0,
      studentName: '',
      inputCourse: '',
      inputClass: '',
      addClassForm: {
        className: '',
        gradeName: '',
        schoolId: ''
      },
      addStudentForm: {
        studentName: '',
        studentCode: '',
        classValue1: '',
        schoolId: '',
        birthday: '',
        sex: '',
        id: ''
      },
      dialogVisible: false,
      dialogVisible1: false,
      input2: '',
      studentListArray: [],
      addStudentFormRules: {
        studentName: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        classValue1: [
          { required: true, message: '请选择班级', trigger: 'change' }
        ],
        birthday: [
          { required: true, message: '请选择出生日期', trigger: 'change' }
        ],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }]
      },
      classInfoArray: [],
      classValue: '',
      courseValue: '',
      classValue1: '',
      schoolId: null,
      pagination: {
        offset: 0,
        total: 0,
        currentPage: 1,
        limit: 100
      },
      teacherArray: []
    };
  },
  mounted() {
    this.studentList();
    this.classInfoI();
    this.schoolList();
  },
  watch: {
    $route: {
      handler: function (val) {
        // console.log(val.query.id);
        this.schoolId = val.query.id;
        this.studentList();
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  methods: {
    numTochinese,
    //输入框清空
    clearClick() {
      this.studentName = '';
      this.studentList();
    },
    // 添加学生
    addClassDialog() {
      this.dialogVisible1 = true;
      //   this.addStudentForm.studentCode = new Date().getTime();
    },
    // 所属学校
    async schoolList() {
      try {
        let parmas = {
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.limit
        };
        const { data } = await schoolList(parmas);
        this.teacherArray = data;
      } catch (err) {
        console.log(err);
      }
    },
    // 筛选查询
    searchClick() {
      this.studentList();
    },
    async classInfoI() {
      let parmas = {
        pageNum: '',
        pageSize: ''
      };
      await classInfo(parmas)
        .then((res) => {
          if (res.code == 0) {
            this.classInfoArray = res.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleChangePage(currentPage) {
      this.pagination.currentPage = currentPage;
      this.studentList();
    },
    async addClassI() {
      let data = {
        grade: this.addClassForm.gradeName,
        number: this.addClassForm.className,
        schoolId: this.addClassForm.schoolId
      };
      await addClass(data)
        .then((res) => {
          if (res.code == 0) {
            this.dialogVisible = false;
            this.$message.success('添加班级成功');
            this.$refs.addClassFormRef.resetFields();
            this.addClassForm = JSON.parse(
              JSON.stringify(this.$options.data().addClassForm)
            );
            this.classInfoI();
          } else {
            this.$message.error(res.message);
            this.dialogVisible = false;
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
          this.dialogVisible = false;
          console.log(error);
        });
    },
    // 添加学生
    async addStudent() {
      let params = {
        classId: this.addStudentForm.classValue1,
        name: this.addStudentForm.studentName,
        studentCode: this.addStudentForm.studentCode,
        schoolId: this.addStudentForm.schoolId,
        birthday: this.addStudentForm.birthday,
        sex: this.addStudentForm.sex
      };
      await addStudent(params)
        .then((res) => {
          if (res.code == '0') {
            this.dialogVisible1 = false;
            this.$refs.addStudentForm.resetFields();
            this.$message.success('添加成功');
            this.studentList();
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    // 学生列表
    async studentList() {
      let parmas = {
        classId: this.classValue,
        courseId: '',
        name: this.studentName,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.limit,
        schoolId: this.schoolId
      };
      await studentList(parmas).then((res) => {
        if (res.code == 0) {
          this.studentNums = res.total;
          this.studentListArray = res.data;
          this.pagination.total = res.total;
        }
      });
    },
    addDialogVisible() {
      this.dialogVisible = true;
      this.addClassI();
    },
    addStudentVisible() {
      this.$refs.addStudentForm.validate((isOk) => {
        if (isOk) {
          if (this.addStudentForm.id) {
            this.updaStudent();
          } else {
            this.addStudent();
          }
        }
      });
    },
    //修改
    async updaStudent() {
      let params = {
        classId: this.addStudentForm.classValue1,
        name: this.addStudentForm.studentName,
        classValue1: this.addStudentForm.classValue1,
        schoolId: this.addStudentForm.schoolId,
        birthday: this.addStudentForm.birthday,
        sex: this.addStudentForm.sex,
        id: this.addStudentForm.id
      };
      await updaStudent(params)
        .then((res) => {
          if (res.code == '0') {
            this.dialogVisible1 = false;
            this.$refs.addStudentForm.resetFields();
            this.studentList();
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    // 取消按钮
    cancleClick() {
      this.$refs.addStudentForm.resetFields();
      this.dialogVisible1 = false;
    },
    //编辑
    updataStudent(value) {
      setTimeout(() => {
        this.dialogVisible1 = true;
      }, 500);
      this.addStudentForm.studentName = value.name;
      this.addStudentForm.classValue1 = value.classId;
      this.addStudentForm.schoolId = value.schoolId;
      this.addStudentForm.birthday = value.birthday;
      this.addStudentForm.id = value.id;
    },
    //  新增量表
    goTopic() {
      this.$router.push({
        name: 'scale'
      });
    }
  }
};
</script>


<style lang="scss" scoped>
.samllBox {
  height: 100vh;
}
.bigBox {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.box_1 {
  // width: 23px;
  display: flex;
  justify-content: center;
  //   margin-left: -100px;
  height: 44px;

  .text_1 {
    width: 111px;
    height: 44px;
    color: #8a70d6;
    font-size: 26px;
    font-weight: bold;
    font-family: MicrosoftYaHei-Bold;
    text-align: left;
    white-space: nowrap;
    line-height: 44px;
  }
}

.box_2 {
  width: 1500px;
  // height: 44px;
  // margin: 6px 0 0 395px;
  margin-top: 12px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .box2_1 {
    width: 600px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .search-btn {
      margin-right: 20px;
    }
    .course-btn {
      margin-right: 20px;
    }
    .class-btn {
      margin-right: 20px;
    }
    .el-dropdown-link {
      cursor: pointer;
      color: #409eff;
    }
  }
  .box2_2 {
    // width: 110px;
    height: 22px;

    .addButton {
      font-size: 18px;
      text-align: center;
      line-height: 22px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #8a70d6;
    }
  }
}
::v-deep .el-icon-plus {
  color: #8a70d6;
  font-size: 16px;
  font-weight: bold;
  margin-left: 20px;
  margin-right: 6px;
}
::v-deep .el-pagination {
  text-align: center;
  margin-top: 20px;
}
</style>